import getParentState from '../selectors';
import { AppState } from 'state/types';
import { LicenseState } from './reducer';

export function getLicense(state: AppState): LicenseState {
  return getParentState(state).license;
}
